'use memo'

import { useEffect, useState } from 'react'
import EnvHandler from '@sportninja/common/utils/env-handler-setup'

interface ApiBaseUrlState {
  /** `null` when unknown or unavailable. */
  apiBaseUrl: string | null
  /** False until the lookup has settled, either way. */
  resolved: boolean
}

/**
 * The API base this web app talks to (e.g. `http://localhost:8080/v1`), so a
 * local plugin build in the preview reads the same API.
 */
export const useApiBaseUrl = (): ApiBaseUrlState => {
  const [apiBaseUrl, setApiBaseUrl] = useState<string | null>(null)
  const [resolved, setResolved] = useState(false)

  useEffect(() => {
    let cancelled = false
    EnvHandler.get()
      .then((value: string | false | null) => value || null)
      // No API base: the preview still loads, just without `sn-api`.
      .catch(() => null)
      .then((value: string | null) => {
        if (!cancelled) {
          setApiBaseUrl(value)
          setResolved(true)
        }
      })
    return () => {
      cancelled = true
    }
  }, [])

  return { apiBaseUrl, resolved }
}
